import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Check, Zap, Users, Building2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const PLAN_ICONS = { plan_basico: Zap, plan_profissional: Users, plan_empresarial: Building2 };
const PLAN_LABELS = { plan_basico: 'Básico', plan_profissional: 'Profissional', plan_empresarial: 'Empresarial' };
const PLAN_PRICES = { plan_basico: 'R$69', plan_profissional: 'R$102', plan_empresarial: 'R$164' };
const PLAN_DESC = { plan_basico: '1 funcionário', plan_profissional: 'Até 5 funcionários', plan_empresarial: 'Até 10 funcionários' };

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { refreshUser } = useAuth();
  const [ready, setReady] = useState(false);

  const status = params.get('status') || 'approved';
  const planId = params.get('external_reference') || 'plan_profissional';
  const Icon = PLAN_ICONS[planId] || Users;
  const success = status === 'approved' || status === 'success';

  useEffect(() => {
    const token = localStorage.getItem('orcfacil_token');
    if (success && token) refreshUser?.().catch(() => {}).finally(() => setReady(true));
    else setReady(true);
  }, []);

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center p-4">
      <div className="max-w-sm w-full text-center space-y-6 animate-fade-in">

        {/* Logo */}
        <img src="/icon-192.png" alt="OrcFácil" className="w-16 h-16 rounded-2xl object-cover mx-auto shadow-[0_0_30px_rgba(249,115,22,0.3)]" />

        {success ? (
          <>
            {/* Success checkmark */}
            <div className="w-24 h-24 bg-green-500/15 rounded-full flex items-center justify-center mx-auto ring-4 ring-green-500/25">
              <Check size={44} className="text-green-400" strokeWidth={2.5} />
            </div>

            <div className="space-y-1">
              <h1 className="font-heading text-3xl font-black text-white">Assinatura Ativada!</h1>
              <p className="text-zinc-400 text-sm">Seu pagamento foi confirmado com sucesso.</p>
            </div>

            {/* Plan card */}
            <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-5 space-y-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-orange-500 rounded-xl flex items-center justify-center">
                  <Icon size={18} className="text-white" />
                </div>
                <div className="text-left">
                  <div className="font-semibold text-white">Plano {PLAN_LABELS[planId] || 'Pro'}</div>
                  <div className="text-xs text-zinc-500">{PLAN_DESC[planId] || ''}</div>
                </div>
                <div className="ml-auto text-xl font-black text-orange-400 font-mono">
                  {PLAN_PRICES[planId] || ''}<span className="text-sm text-zinc-500">/mês</span>
                </div>
              </div>
            </div>

            <button
              data-testid="pagto-ok-start-btn"
              onClick={() => navigate('/')}
              className="w-full bg-orange-500 hover:bg-orange-400 text-white font-bold py-3.5 rounded-xl transition-colors text-base"
            >
              Começar a usar
            </button>
          </>
        ) : (
          <>
            {/* Failure state */}
            <div className="w-24 h-24 bg-red-500/15 rounded-full flex items-center justify-center mx-auto ring-4 ring-red-500/25">
              <span className="text-4xl text-red-400">✕</span>
            </div>
            <h1 className="font-heading text-2xl font-bold text-white">Pagamento não concluído</h1>
            <p className="text-zinc-400 text-sm">Houve um problema com o seu pagamento. Tente novamente.</p>
            <button onClick={() => navigate('/subscribe')}
              className="w-full bg-orange-500 hover:bg-orange-400 text-white font-bold py-3.5 rounded-xl transition-colors">
              Tentar novamente
            </button>
          </>
        )}

        <p className="text-xs text-zinc-600">Powered by <span className="text-orange-500 font-semibold">OrcFácil</span></p>
      </div>
    </div>
  );
}
